import { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context';
import { Icon } from '../Icon';
import './Header.scss';
import { Button } from '@mui/material';

export const Header = () => {
    const navigate = useNavigate();
    const { isLoggedIn } = useContext(AuthContext);

    return (
        <header className="Header">
            <Link to="/" className='title'>
                <Icon 
                    name='book'
                />
                <h1>Grimoire</h1>
            </Link>
            { isLoggedIn ? 
                <>
                    <Link to="settings">
                        <Icon 
                            name='gear'
                        />
                    </Link>
                </>
            :
                <Button 
                    variant='contained'
                    onClick={() => navigate('/emaillinksignin')}
                >
                    Sign in
                </Button>
            }
        </header>
    );
};